import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { getDashboardsPagePath } from "utils/router.utils.js";

import SystemCard from "./SystemCard.js";

/* compare old ui and new ui branches/dev changes to be incorporated with regression */

const SystemsCardsContainer = ({ systems, selectedSystem, filterValue, setFilterSystems, activeAlarms }) => {
  if (selectedSystem && selectedSystem.length > 0 && selectedSystem[0].systemStatus !== "" && selectedSystem[0].connectionStatus !== "") {
    systems = systems.filter(o1 => selectedSystem.some(o2 => o1.systemStatus === o2.systemStatus && o1.connectionStatus === o2.connectionStatus));
  }

  systems = systems.filter(sys => {
    const filterText = filterValue?.toLowerCase() || "";
    return sys.systemName?.toLowerCase().includes(filterText) || sys.sysId?.toLowerCase().includes(filterText);
  });

  useEffect(() => {
    setFilterSystems(systems.length);
  }, [systems]);

  return (
    <div>
      <div className="list__container">
        {systems.map(item => (
          <Link to={getDashboardsPagePath(item.sysId)} key={item.sysId}>
            <SystemCard system={item} activeAlarms={activeAlarms} />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SystemsCardsContainer;
